<svg width="100%" height="100%" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
  <rect x="4" y="6" width="11" height="16" rx="2" stroke="#777777" />
  <rect x="8" y="2" width="11" height="16" rx="2" stroke="#777777" />
</svg>
